import Endereco from '@/models/objetosDeValor/Endereco';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { Estado, Pais } from '@/models/Enums';
import { SiglaUf } from '@/models/enums/EnumEndereco';

export class EnderecoService {
    private static readonly _url = 'https://viacep.com.br/ws/';

    private static getEstadoBySigla(sigla: string): number {
      const index = Object.values(SiglaUf).findIndex((s) => s === sigla);
      return index >= 0 ? index : 0; // 0 = NaoInformado
    }

    public async get(cep: string) {
      return new Promise<Endereco>((resolve, reject) => {
        axios.get(`${EnderecoService._url}${cep}/json/`)
          .then((response: AxiosResponse) => {
            const address = new Endereco();
            address.cep = response.data.cep;
            address.logradouro = response.data.logradouro;
            address.bairro = response.data.bairro;
            address.cidade = response.data.localidade;

            address.estado = EnderecoService.getEstadoBySigla(response.data.uf);
            address.uf = EnderecoService.getEstadoBySigla(response.data.uf);

            address.pais = Pais.findIndex((pais) => pais.text === 'Brasil');

            resolve(address);
          })
          .catch((error: AxiosError) => {
            const err = error.response ? error.response.data : '';
            reject(err);
          });
      });
    }
}
